<div class="summary">
  <div class="summary_content">
    <h3 class="font-sans text-h400 md:text-h600 text-eggplant-100/[0.25]">{{ 'OVERVIEW.DOCUMENTATION.SUMMARY' | translate }}</h3>
    <div class="summary_container">
      <div class="subtitle_container">
        <p class="subtitle_static text-eggplant-100 text-l md:text-xl lg:text-h400 font-sans">{{ 'OVERVIEW.DOCUMENTATION.SUMMARY_SUBTITLE' | translate }}</p>
      </div>

      <!-- FAQs generales (SimpleLocalize) -->
      <ng-container *ngIf="generalFaqsDocs.length > 0">
        <p class="font-sans text-eggplant-100 text-xl md:text-2xl faqs-group-title">{{ 'OVERVIEW.DOCUMENTATION.GENERAL_FAQS' | translate }}</p>
        <div *ngFor="let element of generalFaqsDocs" class="summary-c border-t border-t-eggplant-100/[0.25]">
          <div class="more-btn" (click)="openItem(element)">
            <div class="sp1"></div>
            <div class="sp2" [ngClass]="{'rotate2': element.opened, 'rotate1': !element.opened}"></div>
          </div>
          <h4 (click)="openItem(element)" class="font-sans text-eggplant-100 text-l">{{ element.title }}</h4>
          <div class="summary_text" [id]="element.idContent" [innerHTML]="element.content"
            [ngClass]="{'hideContent': !element.opened, 'showContent': element.opened}"></div>
        </div>
      </ng-container>

      <!-- FAQs específicas (API locale.faqs) -->
      <ng-container *ngIf="specificFaqsDocs.length > 0">
        <p class="font-sans text-eggplant-100 text-xl md:text-2xl faqs-group-title">{{ 'OVERVIEW.DOCUMENTATION.SPECIFIC_FAQS' | translate }}</p>
        <div *ngFor="let element of specificFaqsDocs" class="summary-c border-t border-t-eggplant-100/[0.25]">
          <div class="more-btn" (click)="openItem(element)">
            <div class="sp1"></div>
            <div class="sp2" [ngClass]="{'rotate2': element.opened, 'rotate1': !element.opened}"></div>
          </div>
          <h4 (click)="openItem(element)" class="font-sans text-eggplant-100 text-l">{{ element.title }}</h4>
          <div class="summary_text" [id]="element.idContent" [innerHTML]="element.content"
            [ngClass]="{'hideContent': !element.opened, 'showContent': element.opened}"></div>
        </div>
      </ng-container>

      <!-- FAQs contractuales (API locale.contract_summary) -->
      <ng-container *ngIf="contractDocs.length > 0">
        <p class="font-sans text-eggplant-100 text-xl md:text-2xl faqs-group-title">{{ 'OVERVIEW.DOCUMENTATION.CONTRACT_FAQS' | translate }}</p>
        <div class="subtitle_container" *ngIf="hasSection">
          <div class="section-info" id="sectionInfo" [innerHTML]="sectionInfo" [ngClass]="{'hideSection': !viewMore, 'openSection': viewMore}"></div>
          <div *ngIf="!viewMoreBlur" class="blur-content"></div>
          <h5 (click)="toggleSection()">
            <span *ngIf="!viewMore">{{ 'INFO.BTN_MSG_BALEARES' | translate }}</span>
            <span *ngIf="viewMore">{{ 'INFO.BTN_MSG_LESS' | translate }}</span>
          </h5>
        </div>
        <div *ngFor="let element of contractDocs" class="summary-c border-t border-t-eggplant-100/[0.25]">
          <div class="more-btn" (click)="openItem(element)">
            <div class="sp1"></div>
            <div class="sp2" [ngClass]="{'rotate2': element.opened, 'rotate1': !element.opened}"></div>
          </div>
          <h4 (click)="openItem(element)" class="font-sans text-eggplant-100 text-l">{{ element.title }}</h4>
          <div class="summary_text" [id]="element.idContent" [innerHTML]="element.content"
            [ngClass]="{'hideContent': !element.opened, 'showContent': element.opened}"></div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
